module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.userLoading),
      expression: "userLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "userGroup"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    class: {
      floatRightStyle: _vm.$i18n.locale === 'ae'
    },
    attrs: {
      "span": 18
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('table.groupMana')))])]), _vm._v(" "), _c('el-col', {
    staticClass: "btn",
    style: ({
      textAlign: _vm.$i18n.locale === 'ae' ? 'left' : 'right'
    }),
    attrs: {
      "span": 6
    }
  }, [(_vm.showAddBtn) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v(_vm._s(_vm.$t('button.add')) + " "), _c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('usergroupList', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "tableTotal": _vm.total,
      "currentPage": _vm.currentPage,
      "tablePageSize": _vm.pageSize
    },
    on: {
      "current-change": _vm.tableCurrentChange,
      "reload-list": _vm.reloadGroupList,
      "pagesize-change": _vm.tablePagesizeChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "addgroupDialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('dialog.addUserGroup'),
      "visible": _vm.addDialog,
      "width": "40%",
      "before-close": _vm.addClose
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": _vm.$i18n.locale == 'en' ? '180px' : '100px',
      "rules": _vm.addRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.groupName'),
      "prop": "groupName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterUserGroupCnName')
    },
    model: {
      value: (_vm.addForm.groupName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "groupName", $$v)
      },
      expression: "addForm.groupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "enGroupName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.enterUserGroupEnName')
    },
    model: {
      value: (_vm.addForm.enGroupName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "enGroupName", $$v)
      },
      expression: "addForm.enGroupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('dialog.groupDesc'),
      "prop": "groupDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 3
      },
      "resize": "none",
      "placeholder": _vm.$t('placeholder.enterUserGroupCnDesc')
    },
    model: {
      value: (_vm.addForm.groupDesc),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "groupDesc", $$v)
      },
      expression: "addForm.groupDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "enGroupDesc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 3
      },
      "resize": "none",
      "placeholder": _vm.$t('placeholder.enterUserGroupEnDesc')
    },
    model: {
      value: (_vm.addForm.enGroupDesc),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "enGroupDesc", $$v)
      },
      expression: "addForm.enGroupDesc"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.addClose
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    on: {
      "click": _vm.addGroupSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92bc7ed4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/userGroup.vue
// module id = 1183
// module chunks = 1